import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
// eslint-disable-next-line
export default function NoOptionsMessage(props) {
    const { t } = useTranslation();
    return (_jsx(components.NoOptionsMessage, Object.assign({}, props, { children: _jsx("span", Object.assign({ className: "custom-css-class" }, { children: t('No options') })) })));
}
//# sourceMappingURL=NoOptionsMessage.js.map